import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import './index.styles.css'
type Props = {
  label: string
  selected: boolean
  onClick: () => void
}

export const Option = ({ label, selected, onClick }: Props) => {
  return (
    <Box
      className={'_Option_clickable'}
      flexDirection="row"
      width="full"
      paddingX="s16"
      paddingY="s12"
      justifyContent="spaceBetween"
      alignItems="center"
      onClick={onClick}
    >
      <Text.Normal lineClamp={2} color="grey1000">
        {label}
      </Text.Normal>
      {selected && (
        <Box flexNoShrink style={selected ? undefined : { display: 'none' }}>
          <Icon.Medium icon="check" color="grey800" />
        </Box>
      )}
    </Box>
  )
}
